import React, {Component} from 'react';
import styles from './SearchResultsMarker.scss';
import PropTypes from 'prop-types';
import { amountFormatting } from '../../lib/formatting';

class SearchResultsMarker extends Component {
  constructor(props) {
    super(props);
    this.categoryIcon = {
      'SaleListing': 'marker-for-sale',
      'RentalListing': 'marker-for-rent',
      'Property': 'marker-offmarket',
      'Sold': 'marker-sold',
    };
  }

  render() {
    this.markerIconImage = 'marker-multiple-properties';
    this.labelStyle = styles['label' + this.props.category];
    if (typeof this.categoryIcon[this.props.category] !== 'undefined') {
      this.markerIconImage = this.categoryIcon[this.props.category];
    }
    this.labelText = 'N/A';
    if (this.props.properties.length > 1) {
      this.labelText = this.props.properties.length + ' properties';
    }
    else {
      let property = this.props.properties[0];
      if (property.listing) {
        if (property.listing.showPrice && property.category !== 'RentalListing') {
          this.labelText = property.listing.displayPrice;
        }
        if (property.category === 'RentalListing') {
          this.labelText = property.listing.displayPrice;
          this.labelText = this.labelText + '/w';
        }
      }
      else {
        if (property.recentlySold) {
          this.markerIconImage = this.categoryIcon['Sold'];
          this.labelText = property.lastSale && property.lastSale.salePrice ? amountFormatting(property.lastSale.salePrice) : 'SOLD';
          this.labelStyle = styles['labelSold'];
        }
        else if (property.guesstimate && property.guesstimate.price) {
          this.labelText = property.guesstimate.fromText + ' - ' + property.guesstimate.toText;
        }
      }
    }
    return (
      <div className={'position-relative'} id={'marker_' + this.props.index}>
        {this.props.label ?
          <React.Fragment>
            <div className={'pr-2 pl-2 text-center d-inline-block smText rounded-sm position-absolute ' + styles.label + ' ' + this.labelStyle}>
              {this.labelText}
            </div>
            {this.props.properties.length > 1 ?
              <img className={styles.markerIcon} src={`/assets/images/map/${this.markerIconImage}.png`} />
              : null}
          </React.Fragment>
          :<img className={styles.markerIcon} src={`/assets/images/map/${this.markerIconImage}.png`} />
        }
      </div>
    );
  }
}

SearchResultsMarker.propTypes = {
  category: PropTypes.string.isRequired,
  properties: PropTypes.array.isRequired,
  label: PropTypes.bool.isRequired,
};

export default SearchResultsMarker;
